
import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../../constants';
import Error from '../../../components/Error/error';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import {loadingButton, loadingButtonEnd} from '../../../functions';
import { ToastContainer, toast } from 'react-toastify';

export default class Enlace extends Component {

    state = {
        resource: [],
        response: [],
        optionsTipoRecurso: [],
        error: []
      }


      handleApprove = async(key) =>
      {  
          console.log(key);
          loadingButton("approve_" + key, "fa-thumb-tack");
          const url = `${API_URL}LinkUX/`;
          axios.get(url+key).then(response => response.data)
          .then((data) => {
              var res=data.result;
              res.bActivo = true;
              const formData = JSON.stringify(res);
              axios.put(
                url, 
                JSON.stringify(formData),
                { headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
                    }
                }
                ).then(
                    (data)=> {             
                        if (data.data.isSucess)
                        {
                            toast.success("Se ha aprobado el enlace");
                            axios.get(url).then(response => response.data)
                            .then((data) => {
                                this.setState({ resource: data.result, response: data, error: data.Error }, ()=>{
                                    loadingButtonEnd("approve_" + key, "fa-lock", true);
                                });
                            })
                            .catch(error => {
                                toast.error('¡Error!: No se pudo cargar los datos');
                            }); 
                        } else 
                        {
                            toast.error("¡Error!: No se pudo aprobar el enlace");
                        }
                    }
                ).catch((error)=> {
                });    
          })
          .catch(error => {
          });        
        
      }

    render() {
        return (
            (this.state.response.statusCode==200)?
            (
                <div id="detailBody" className="Site-content" >
                    <div className="loader"></div> 
                    <div hidden={true} id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div id="Body" className="body-container container-fluid">
                            <div className="content-option" >
                                <div className="row recursos__search section__margin-bottom">
                                    <div className="col-sm-8">
                                        <div className="ibox-content">
                                                <div className="search-form">
                                                        <div className="input-group">
                                                            <i className="recursos__search-icon fas fa-search"></i>
                                                            <input type="text" placeholder="NOMBRE DEL RECURSO" name="search" className="recursos__search-form-control form-control input-lg" />
                                                            <div className="input-group-btn">
                                                                <button className="btn btn-primary btn-primary__submit" type="submit">BUSCAR</button>
                                                            </div>
                                                        </div>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="recursos__wrapper-table">
                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                        <thead>
                                                            <tr>
                                                                <th className="table-bordered-radius--left">CÓDIGO</th>
                                                                <th>DESCRIPCION</th>
                                                                <th>DESTINO</th>
                                                                <th>ENLACE</th>
                                                                <th>TEXTO ALTERNATIVO</th>
                                                                <th className="text-center">ACTIVO</th>
                                                                <th className="table-bordered-radius--right text-center">ACCIÓN</th>
                                                                <th className="table-bordered-radius--right text-center">APROBAR</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.resource.map((resource) => (
                                                            <tr key={resource.nEnlanceCodigo}>
                                                                <td>{resource.nEnlanceCodigo}</td>
                                                                <td>{resource.sTitulo}</td>
                                                                <td>{resource.sTarget}</td>
                                                                <td>{resource.sEnlace}</td>
                                                                <td>{resource.sTextoAlternativo}</td>
                                                                <td className="text-center">
                                                                    {(resource.bActivo?<span className="label label-info">ACTIVO</span>:<span className="label label-warning">INACTIVO</span>)}
                                                                </td>
                                                                <td className="recursos__table-action-option">
                                                                    <button id={"btn_edit"}   className={"btn btn-primary__tool btn-primary"} type="button" onClick={(event) => this.handleEdit(resource.nEnlanceCodigo)} >
                                                                        <i id={"i_edit"} className="fas fa-pen fa-sm"></i>
                                                                    </button>                                                                
                                                                </td>
                                                                <td className="recursos__table-action-option">
                                                                    <button id={"btn_approve_" + resource.nEnlanceCodigo} disabled={resource.bActivo} className={"btn btn-primary__tool "+ (resource.bActivo?"btn-default":"btn-primary")} type="button" onClick={(event) => this.handleApprove(resource.nEnlanceCodigo)} >
                                                                        <i id={"i_approve_" + resource.nEnlanceCodigo} className={"fas fa-sm " + (resource.bActivo?"fa-lock":"fa-thumb-tack")}></i>
                                                                    </button>                                                                
                                                                </td>                                                                
                                                            </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            )
            :
            (
                <Error StatusCode={this.state.response.StatusCode} StatusMessage={this.state.response.StatusMessage}></Error>
            )
        );
    }

    editResource(id){

        this.props.history.push({
            pathname: '//' + id,
            state: { key: id }
          });
    }

    componentDidMount(){
        const url = `${API_URL}LinkUX/`;
            axios.get(url).then(response => response.data)
            .then((data) => {
                this.setState({ resource: data.result, response: data, error: data.Error });
                document.querySelector('.loader').classList.add('loader--hide');
                document.getElementById('content-wrapper').removeAttribute("hidden");
            })
            .catch(error => {
                document.querySelector('.loader').classList.add('loader--hide');
                alert('Error de comunicación');
            });        
    }
}

 